module.exports = __webpack_public_path__ + "img/cultureCode4.d198effa.png";